import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MesaPartesFrameboardComponent } from './mesa-partes-frameboard.component';
import { RouterModule } from '@angular/router';
import { NavbarModule } from '../navbar/navbar.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [MesaPartesFrameboardComponent],
  exports: [MesaPartesFrameboardComponent],
  imports: [
    CommonModule,
    RouterModule,
    NavbarModule,
    MatTooltipModule
  ]
})
export class MesaPartesFrameboardModule { }
